module.exports = __webpack_public_path__ + "static/media/xls.152573d4.svg";